import axios from "axios";

const API_URL = process.env.VUE_APP_TGBOT_API;

// create an axios instance
const service = axios.create({
  baseURL: API_URL,
  timeout: 5000, // request timeout
  withCredentials: true,
});

service.interceptors.request.use((config) => {
  return config;
});

service.interceptors.response.use((config) => {
  return config;
});

export default service;
